import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { loadSingleBatch } from '@reducers/batch';
import { useRoute } from '@react-navigation/native';
import { parseRouteParamAsNumber } from '@helpers';

interface NCFileDetailsNCFileEventsSetupProps {}

const NCFileDetailsNCFileEventsSetupComponent: FC<NCFileDetailsNCFileEventsSetupProps> = ({
  getProductionBatchByNCFile,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
}) => {
  const route = useRoute();
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
    loadSingleBatch,
  });

  const ncFileId = parseRouteParamAsNumber(route.params?.ncFileId);

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.SETUP, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileEventsSetup = connect(null, {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
})(NCFileDetailsNCFileEventsSetupComponent);

export { NCFileDetailsNCFileEventsSetup };
